import { takeLatest, put, call } from 'redux-saga/effects';
import { actionTypes as applicationActions } from '../core/reducers/asyncServerResponseReducer';
import { freeSpinResponseService } from './../gameservice/freeSpinResponseService';
import { configGame, constant } from "./../data/config";
export function* freeSpinSaga(): Generator<any, any, any> {
    yield takeLatest(applicationActions.GET_APPLICATION_FREE_SPIN_RESPONSE, fireSpinResponse);
}


let counter = 0;

function* fireSpinResponse(): Generator<any, any, any> {
    try {
        //localStorage.setItem("cheatModifiedRequest", "")
        // constant.configGame.cheatModifiedRequest = "";
        let result_spin = yield call(freeSpinResponseService.sendFreeSpinResponse);
        // result_spin = JSON.parse(result_spin.response);
        yield put({
            type: applicationActions.GET_APPLICATION_SPIN_SUCCESS,
            result_spin
        });

    } catch (error) {
        yield put({
            type: applicationActions.GET_APPLICATION_SPIN_FAILURE,
            error
        });
    }
}

